import React from 'react';
import NotAvailable from 'components/common/NotAvailable';
import EquDressageIndividualCollapse from './EquDressageIndividualCollapse';

function EquDressageIndividualAllGroups({ results, teamData }) {
  const resultsFiltered = results?.filter( res => res?.data?.results?.items !== undefined);

  if (!resultsFiltered) { return <NotAvailable /> }

  let comp = []
  resultsFiltered?.forEach((res, index) => {
          comp.push(<EquDressageIndividualCollapse key={`results-component-${index}`} data={res.data} />)
  })

  
  return (
    <>
      {comp}
    </>
  );
}

export default EquDressageIndividualAllGroups